import { cn } from '@/lib/utils';

type InfoMessageProps = {
  children: React.ReactNode;
  className?: string;
};

export function InfoMessage({ children, className }: InfoMessageProps) {
  return (
    <div
      className={cn(
        'border-orchid-500 border-l-2 pl-4',
        'text-foreground text-sm leading-[1.15]',
        className
      )}
    >
      {children}
    </div>
  );
}
